module.exports = __webpack_public_path__ + "static/media/product-4-front.ecb7c0b9.jpg";